import { useAppContext } from '../context/AppContext';

export function AppSelector({ className = '' }) {
  const { apps, selectedApp, setSelectedApp, appsLoading } = useAppContext();

  if (apps.length === 0 && !appsLoading) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <label className="text-[10px] uppercase tracking-[0.12em] text-muted shrink-0">App</label>
      <div className="relative">
        <select
          className="appearance-none bg-panel border border-panel-border text-white text-xs rounded-lg pl-3 pr-8 py-1.5 focus:outline-none focus:border-sage-mid cursor-pointer"
          style={{ minWidth: 140 }}
          value={selectedApp?.slug || ''}
          onChange={(e) => {
            const found = apps.find((a) => a.slug === e.target.value);
            setSelectedApp(found || null);
          }}
          disabled={appsLoading}
        >
          <option value="">All Apps</option>
          {apps.map((app) => (
            <option key={app.slug} value={app.slug}>
              {app.name}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-muted text-[10px]">▾</span>
      </div>
      {selectedApp && (
        <span
          className="w-2 h-2 rounded-full shrink-0"
          style={{ backgroundColor: selectedApp.color || '#3e7b6f' }}
        />
      )}
    </div>
  );
}
